import React from 'react';
import { DiaryEntry, DiaryPage as DiaryPageType } from '../../../domain/grandma';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { EffectType } from '../../../domain/status';
import { capitalizeFirstLetter } from '../../../util/string';
import { combineRandomly } from '../../../util/array';
import { cyrb128 } from '../../../util/hash';

interface IDiaryPageProps {
    page: DiaryPageType
}

const excludedKeys = [
    'isAsleep',
];

const convertEntry = (t: TFunction, entry: DiaryEntry): string => {
    const parts: string[] = [];

    entry.appliedEffects.forEach((effect) => {
        if (effect.type === EffectType.Pill) {
            const r = t(`effect.${effect.key}.diary`);
            if (r !== '') parts.push(r);
        }
    });

    entry.tickEffects.forEach((effect) => {
        if (effect.type === EffectType.Ailment) {
            const r = t(`effect.${effect.key}.diary`);
            if (r !== '') parts.push(r);
        }
        if (effect.type === EffectType.Neutral) {
            const r = t(`effect.${effect.key}.diary`);
            if (r !== '') parts.push(r);
        }
    });

    Object.values(entry.state).forEach((status) => {
        if (excludedKeys.includes(status.key)) {
            return;
        }

        const r = t(`game.status.${status.key}.${status.value}`);

        if (r !== '') {
            parts.push(r);
        }
    });

    if (parts.length === 0) {
        return '';
    }

    const hash = cyrb128(JSON.stringify(entry));

    const sentencedParts = combineRandomly(parts, hash[0]);

    return t('diary.entry', {
        time: t(`timer.time.${entry.time}`),
        parts: sentencedParts.map(
            part => capitalizeFirstLetter(part.join(t('diary.combinator')))
        ).join(t('diary.sentenceSeparator')),
    });
};

export const DiaryPage: React.FunctionComponent<IDiaryPageProps> = (props) => {
    const { t } = useTranslation();

    return (
        <section>
            <h3>{props.page.day}</h3>
            {props.page.entries.map((entry) => (
                <p key={entry.time}>
                    {convertEntry(t, entry)}
                </p>
            ))}
        </section>
    );
};
